export const PermanentBin = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
    <path d="m375-293.85 106-106 106 106L647.15-354l-106-106 106-106L587-626.15l-106 106-106-106L314.85-566l106 106-106 106L375-293.85ZM288.31-108q-41.03 0-69.67-28.64T190-206.31V-724h-40v-86h208v-43.38h246V-810h208v86h-40v517.69q0 41.03-28.64 69.67T673.69-108H288.31ZM686-724H276v517.69q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h385.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46V-724Zm-410 0V-194v-530Z" />
  </svg>
);
